import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import AwsRumDomain from "src/serviceClients/aws-rum/awsRum-domain";
import AwsRumRealm from "src/serviceClients/aws-rum/awsRum-realm";
import {RumConfigDependencies} from "src/serviceClients/aws-rum/awsRum-config";

const isValidRumDomain = (domain: AwsRumDomain | null): boolean => {
    return domain === AwsRumDomain.Prod || domain === AwsRumDomain.Gamma;
};

let rumWebClient: AwsRum | null = null;
export const initRum = (reqDomain: AwsRumDomain | null, reqRealm: AwsRumRealm | null): void => {
    // Skip RUM initialization for null values
    if (reqDomain === null || reqRealm === null) {
        console.log('Skipping RUM initialization for unknown environment or region');
        return;
    }

    if (isValidRumDomain(reqDomain)) {
        const endpointDependencies = RumConfigDependencies[reqDomain][reqRealm];
        try {
            const config: AwsRumConfig = {
                sessionSampleRate: 1,
                sessionEventLimit: 0, //this is to ensure there is no limit per session
                dispatchInterval: 60000,
                guestRoleArn: endpointDependencies.guestRoleArn,
                identityPoolId: endpointDependencies.identityPoolId,
                endpoint: endpointDependencies.endpoint,
                telemetries: ['performance', 'errors', 'http'],
                allowCookies: true,
                disableAutoPageView: true,
                enableXRay: false
            };

            const APPLICATION_ID = endpointDependencies.APPLICATION_ID;
            const APPLICATION_VERSION = endpointDependencies.APPLICATION_VERSION;
            const APPLICATION_REGION = endpointDependencies.APPLICATION_REGION;

            rumWebClient = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);

            console.log(`CloudWatch RUM initialized for ${reqDomain} stage and ${reqRealm} region`);

            // Test custom event after a delay to ensure RUM is ready
            setTimeout(() => {
                if (rumWebClient) {
                    rumWebClient.recordEvent('rum_initialized', {
                        stage: reqDomain,
                        region: reqRealm,
                        timestamp: Date.now()
                    });
                }
            }, 2000);

        } catch (error) {
            console.error('CloudWatch RUM initialization failed:', error);
        }
    } else {
        return;
    }
};
export const awsRum = {
    recordEvent(eventType: string, eventData: object): void {
        rumWebClient && rumWebClient.recordEvent(eventType, eventData);
    },

    recordPageView(uiPageId: string): void {
        rumWebClient && rumWebClient.recordPageView({ pageId: uiPageId });
    }
};
